import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './styles.css'; 

const EllipsisWithTooltip = ({ text }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="ellipsis-tooltip">{text}</Tooltip>}
    >
      <span className="ellipsis">{text}</span>
    </OverlayTrigger>
  );
};

export default EllipsisWithTooltip;